import { layout } from 'app_previous/styles/layout';
import styled, { css } from 'styled-components';

interface BaseModalContainerProps {
  isVisible: boolean;
}

export const BaseModalContainer = styled.div<BaseModalContainerProps>`
  position: fixed;
  left: 0;
  top: 0;
  max-width: 100% !important;
  max-height: 100%;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  visibility: hidden;
  z-index: 200;
  transition: all 500ms ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    !props.isVisible
      ? ''
      : css`
          opacity: 100%;
          visibility: visible;
        `}

  @media screen and (max-width: ${layout.sm}) {
    padding: 0 1.5rem;
    box-sizing: border-box;
  }
`;

export const BackgroundOverlay = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 10;

  svg {
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
`;

interface BaseContentProps {
  width?: number | string;
}

export const BaseContent = styled.div<BaseContentProps>`
  position: relative;
  max-width: ${(props) => (typeof props.width === 'number' ? `${props.width}px` : props.width)};
  width: 100%;
`;
